export class modelRequiredCommon {
  origin: required.pin = {
    name: false,
    phoneNumber: false,
    jibunAddress: false,
    detailAddress: false,
  };
  destination: required.pin = {
    name: false,
    phoneNumber: false,
    jibunAddress: false,
    detailAddress: false,
  };
  policy = false;
}

export class modelRequiredQuick extends modelRequiredCommon {
  item: required.item = {
    category: false,
    weight: false,
    price: false,
  };
}

export class modelRequiredParcel extends modelRequiredCommon {
  item: required.item = {
    category: false,
    price: false,
    size: false,
  };
}
